import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-393080d0")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_AccountingInfoHeader = _resolveComponent("AccountingInfoHeader")
  const _component_AccountingInfoDetails = _resolveComponent("AccountingInfoDetails")
  const _component_MobileFooterActions = _resolveComponent("MobileFooterActions")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_AccountingInfoHeader, {
      name: _ctx.$t('provider.accounting-info'),
      editMode: true,
      onBack: _ctx.back,
      onSave: _ctx.save
    }, null, 8, ["name", "onBack", "onSave"]),
    _createVNode("div", null, [
      _createVNode(_component_AccountingInfoDetails, {
        onTabChanged: _ctx.onTabChanged,
        ref: "details",
        tab: _ctx.tab,
        editMode: true
      }, null, 8, ["onTabChanged", "tab"])
    ]),
    _createVNode(_component_MobileFooterActions, {
      editMode: true,
      onBack: _ctx.back,
      form: 'accounting-info'
    }, null, 8, ["onBack"])
  ]))
})